@if (shouldShowPermissionRequest()) {
    <div class="notification-permission-overlay">
        <mat-card class="permission-card">
            <div class="permission-header">
                <h2>Få besked om nye dokumenter</h2>
            </div>

            <div class="permission-content">
                @if (shouldOverwriteExistingSubscription()) {
                    <p>Der er allerede tilmeldt notifikationer for en anden bruger på denne enhed. Vil du overskrive og aktivere for denne bruger?</p>
                } @else {
                    <p>Få besked på din telefon når der er nyheder fra din forsyning.</p>
                }
            </div>

            <div class="permission-actions">
                <button mat-raised-button color="primary" (click)="requestPermission()" [disabled]="isLoading()" class="allow-button">
                    <mat-icon class="button-icon" svgIcon="menu-beskeder"></mat-icon>
                    {{ isLoading() ? "Aktiverer..." : shouldOverwriteExistingSubscription() ? "Tillad og overskriv" : "Tillad notifikationer" }}
                </button>

                @if (shouldOverwriteExistingSubscription()) {
                    <button mat-button (click)="cancelOverwriteRequest()" [disabled]="isLoading()" class="block-button">
                        <mat-icon class="button-icon" svgIcon="close"></mat-icon>
                        Annuller
                    </button>

                    <button mat-button (click)="blockNotifications()" [disabled]="isLoading()" class="block-button">
                        <mat-icon class="button-icon" svgIcon="block"></mat-icon>
                        Fjern notifikationer
                    </button>
                } @else {
                    <button mat-button (click)="blockNotifications()" [disabled]="isLoading()" class="block-button">
                        <mat-icon class="button-icon" svgIcon="block"></mat-icon>
                        Tillad ikke notifikationer
                    </button>
                }
            </div>
        </mat-card>
    </div>
}
